export default {
    data: () => ({
        btnLoading: false,
        server_errors: {
            transport_type: '',
            address_country: '',
            shipping_rates: '',
            volumetric_weight_formula: '',
        },
        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        ValidateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.EditItem();
                }
            });
        },
        EditItem() {
            this.btnLoading = true;
            const payload = {
                transport_type: this.shippingRate.transport_type,
                address_country: this.shippingRate.address_country,
                shipping_rates: this.shippingRate.shipping_rates,
                volumetric_weight_formula: this.shippingRate.volumetric_weight_formula,
            };
            this.$http.put('shipping-rate/' + this.shippingRate.id, payload).then((res) => {
                if (res.data && res.data.error === false) {
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                } else {
                    this.btnLoading = false;
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            }).catch((error) => {
                this.btnLoading = false;
                if (error.response && error.response.status === 422) {
                    const obj = error.response.data.errors || {};
                    for (const [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                } else {
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            });
        },
    },
};
